import React from "react";
import styled, { keyframes } from "styled-components";

const shimmer = keyframes`
  to {
    background-position: 200% 100%;
  }
`;

const RectangularSkeletonWrapper = styled.div`
  width: 100%; /* Adjust the width as needed */
  height: 625px; /* Adjust the height as needed */
  border-radius: 8px;
  overflow: hidden;
  background-color: #f0f0f0; /* Set the background color of the skeleton */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: linear-gradient(90deg, #24242400, #4d4d4ded, #f0f0f000);
  background-size: 200% 100%;
  animation: ${shimmer} 1s infinite;
`;

const SkeletonRow = styled.div`
  height: 10px; /* Adjust the row height as needed */
  background: #151a1c;
  /* background-size: 200% 100%; */
  /* animation: ${shimmer} 1.5s infinite; */
`;

const RectangularSkeleton = () => {
  return (
    <RectangularSkeletonWrapper>
      <SkeletonRow></SkeletonRow>
      <SkeletonRow></SkeletonRow>
      <SkeletonRow></SkeletonRow>
    </RectangularSkeletonWrapper>
  );
};

export default RectangularSkeleton;
